import { FC } from 'react';
import { MAXIMUM_REGISTRATION_AGE, MINIMUM_REGISTRATION_AGE } from '@belong/validation';
import { LIB_INPUTS_DEFAULT_IDS } from '../../../helpers/variables';
import { GenericDateInput } from '../GenericDateInput';
import { IExtendedGenericInputDefaultContent } from '../GenericInput';
import CONTENT from './content.json';

export interface IDateOfBirthInputProps extends IExtendedGenericInputDefaultContent<
  'required' | 'invalid' | 'isMinimumAge' | 'isMaximumAge'
> {}

/**
 * A simple library agnostic DoB input. It validates according to Belong's valid date of birth rules, it handles form errors when implemented with the useForm hook
 */
export const DateOfBirthInput: FC<IDateOfBirthInputProps> = ({
  description = CONTENT.description,
  errorMessages,
  label = CONTENT.label,
  placeholder = CONTENT.placeholder,
  ...props
}) => {
  const errorValidation = { ...CONTENT.errorMessages, ...errorMessages };
  return (
    <GenericDateInput
      autoComplete="bday"
      errorValidation={[
        { errorKey: 'required', message: errorValidation.required },
        { errorKey: 'validDate', message: errorValidation.invalid },
        { errorKey: 'isMinimumAge', message: errorValidation.isMinimumAge, age: MINIMUM_REGISTRATION_AGE },
        { errorKey: 'isMaximumAge', message: errorValidation.isMaximumAge, age: MAXIMUM_REGISTRATION_AGE }
      ]}
      description={description}
      label={label}
      name={LIB_INPUTS_DEFAULT_IDS.DOB}
      placeholder={placeholder}
      {...props}
    />
  );
};

DateOfBirthInput.displayName = 'DateOfBirthInput';
